/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Origin } from './Origin';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
    OriginToJSONTyped,
} from './Origin';

/**
 * 
 * @export
 * @interface PaymentWorkItemResponse
 */
export interface PaymentWorkItemResponse {
    /**
     * 
     * @type {string}
     * @memberof PaymentWorkItemResponse
     */
    workItemId: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentWorkItemResponse
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentWorkItemResponse
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentWorkItemResponse
     */
    currency: string | null;
    /**
     * 
     * @type {any}
     * @memberof PaymentWorkItemResponse
     */
    transactionDate: any | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentWorkItemResponse
     */
    failureReason: string | null;
    /**
     * 
     * @type {Origin}
     * @memberof PaymentWorkItemResponse
     */
    origin: Origin;
}



/**
 * Check if a given object implements the PaymentWorkItemResponse interface.
 */
export function instanceOfPaymentWorkItemResponse(value: object): value is PaymentWorkItemResponse {
    if (!('workItemId' in value) || value['workItemId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('transactionDate' in value) || value['transactionDate'] === undefined) return false;
    if (!('failureReason' in value) || value['failureReason'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function PaymentWorkItemResponseFromJSON(json: any): PaymentWorkItemResponse {
    return PaymentWorkItemResponseFromJSONTyped(json, false);
}

export function PaymentWorkItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentWorkItemResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'workItemId': json['workItemId'],
        'status': json['status'],
        'amount': json['amount'],
        'currency': json['currency'],
        'transactionDate': json['transactionDate'],
        'failureReason': json['failureReason'],
        'origin': OriginFromJSON(json['origin']),
    };
}

export function PaymentWorkItemResponseToJSON(json: any): PaymentWorkItemResponse {
    return PaymentWorkItemResponseToJSONTyped(json, false);
}

export function PaymentWorkItemResponseToJSONTyped(value?: PaymentWorkItemResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workItemId': value['workItemId'],
        'status': value['status'],
        'amount': value['amount'],
        'currency': value['currency'],
        'transactionDate': value['transactionDate'],
        'failureReason': value['failureReason'],
        'origin': OriginToJSON(value['origin']),
    };
}

